import api from '@/api';

const { $pricing, $commission, $academic } = api;

export const { $types, $products } = $pricing;
export const { $weekObjetive, $range, $sellers, $rangeObjective, $commissions } = $commission;
export const { $careers } = $academic;